import React from 'react'

import CryptoChart from './CryptoChart'
import { CoinStore, POLONIEX_ENABLED } from '../stores/CoinStore'

// organize 2x2 charts
export default class Charts extends React.Component {
	state = {
		charts: [],
		interval: 900,
		chartStart: null,
		chartEnd: null,
	}

	pixelRatio() {
    var ctx = document.createElement("canvas").getContext("2d"),
        dpr = window.devicePixelRatio || 1,
        bsr = ctx.webkitBackingStorePixelRatio ||
              ctx.mozBackingStorePixelRatio ||
              ctx.msBackingStorePixelRatio ||
              ctx.oBackingStorePixelRatio ||
              ctx.backingStorePixelRatio || 1;

    return dpr / bsr;
  }

  componentWillMount() {
  	// calculate once for all
  	this.pixelRatio = this.pixelRatio()

  	this.updateStartEnd()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.interval !== this.props.interval) {
      this.updateStartEnd()
    }
  }

  updateStartEnd = () => {
  	let {interval} = this.props;
		
		// find out start and end according to interval
		var end = new Date();
		var start = new Date(end.getTime() - 86400*2*1000) // 2 day ago for 300
		switch (interval) {
			case 900: start = new Date(end.getTime() - 86400*7*1000); break;
			case 1800: start = new Date(end.getTime() - 86400*30*1000); break;
			case 7200: start = new Date(end.getTime() - 86400*60*1000); break;
			case 14400: start = new Date(end.getTime() - 86400*90*1000); break;
			case 86400: start = new Date(end.getTime() - 86400*180*1000); break;
			default: break;
		}
		// round start time to multiples of interval
		var t = Math.round(start.getTime()/1000);
		t = t - (t % interval)
		start = new Date(t * 1000)

		this.setState({
			chartStart: start,
			chartEnd: end,
		})
  }

  chart = (symbol, props) => {
  	if (!symbol) return

  	return <CryptoChart
      symbol={symbol}
      onClick={(e) => this.props.onChartClick(symbol, e)}
      onClose={() => this.props.onChartClose(symbol)}
      {...props}
		/>
  }

	render() {
		let {layout, interval} = this.props

		if (layout.length === 0) {
			return this.empty()
		}

		var start = this.state.chartStart
		var end = this.state.chartEnd

		// which source to use
		var source = PoloniexDataSource
		if (!POLONIEX_ENABLED) source = DebugSource

		return (<div>
			{
				layout.map((symbol, idx) => {
					var classes = (idx % 2 === 0) ? 'fl' : 'fr'
					classes += ' w-100-m w-50-l'
					// clear left if 3rd box, we should really do grouping
					if (idx === 2) classes += ' cl'

					return <div key={idx} className={classes}>
						{this.chart(symbol, {
							width: 600,
							height: 310,
							ratio: this.pixelRatio,
							interval: interval,
							start: start,
							end: end,
							dataSource: source
						})}
					</div>
				})
			}
		</div>)
	}

	empty() {
		return (
			<div className='pa2'>
				Click on Currencies to add charts.
			</div>
		)
	}
}

function PoloniexDataSource(opts) {
  let {symbol, start, end, interval} = opts

  var url = 'https://poloniex.com/public?command=returnChartData&currencyPair=' + symbol
    + '&start=' + Math.round(start.getTime()/1000)
    + '&end=' + Math.round(end.getTime()/1000)
    + '&period=' + interval
  console.log(url)

	return CoinStore.request(() => {
    return fetch(url)
  })
}

function DebugSource(opts) {
	let {symbol, start, end, interval} = opts

  var url = 'https://poloniex.com/public?command=returnChartData&currencyPair=' + symbol
    + '&start=' + Math.round(start.getTime()/1000)
    + '&end=' + Math.round(end.getTime()/1000)
    + '&period=' + interval
  console.log(url)

  url = "/api/price.json"
  return CoinStore.request(() => {
    return fetch(url)
  })
}



// WEBPACK FOOTER //
// ./src/components/Charts.js